import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import {
  Button,
  ButtonGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "ui";

import { ConfigurableFilters } from "src/components/ConfigurableFilters";
import { useDataTableContext } from "src/components/DataTableContext";

export function DataTableToolbar() {
  const { t } = useTranslation();
  const context = useDataTableContext();
  const hasToolbarActions =
    context.filterConfig.length > 0 || context.hasActiveFilters;

  return (
    <div className="space-y-2 p-4">
      <div className="flex flex-wrap items-center gap-2">
        <InputGroup className="flex-1 min-w-[220px] max-w-sm">
          <InputGroupAddon align="inline-start">
            <Icon
              name={context.isFetching ? "tabler-loader-2" : "tabler-search"}
              className={context.isFetching ? "animate-spin" : undefined}
            />
          </InputGroupAddon>
          <InputGroupInput
            value={context.search}
            onChange={(event) => {
              context.onSearchChange(event.target.value);
            }}
            placeholder={
              context.searchPlaceholder ?? t("dataTable.searchPlaceholder")
            }
          />
        </InputGroup>
        {hasToolbarActions ? (
          <ButtonGroup>
            {context.filterConfig.length > 0 ? (
              <ConfigurableFilters
                label={t("dataTable.filters")}
                clearLabel={t("dataTable.clearFilters")}
                config={context.filterConfig}
                selectedFilters={context.selectedFilters}
                saveAction={context.filterSaveAction}
                onAction={(action) => {
                  if (action.type === "filters-cleared") {
                    context.clearFilters();
                    return;
                  }

                  context.onFilterAction(action);
                }}
              />
            ) : null}
            {context.hasActiveFilters && !context.hideClearFilters ? (
              <Button
                variant="outline"
                size="icon-sm"
                aria-label={t("dataTable.clearFilters")}
                onClick={context.clearFilters}
              >
                <Icon name="tabler-x" />
              </Button>
            ) : null}
          </ButtonGroup>
        ) : null}
        {context.toolbarTrailing ? (
          <div className="ml-auto">{context.toolbarTrailing}</div>
        ) : null}
      </div>
      {context.toolbarSecondaryContent}
    </div>
  );
}
